export default __webpack_public_path__ + "static/media/soc-twitter.f6dbaae2.svg";